import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'store/store'
import { Customer } from 'lib/graphql/storefront'

const initialState: Customer = {
  id: null,
  bookableFlag: null,
  email: null,
  address: {
    address1: null,
    zip: null,
    city: null,
    address2: null,
    country: null,
    countryCode: null,
    prefecture: null,
    prefectureCode: null,
  },
  firstName: null,
  lastName: null,
  auth0Id: null,
  createdAt: null,
  isActive: null,
  updatedAt: null,
  fullname: null,
  note: null,
  phone: null,
  tags: null,
  type: null,
  metaFields: null
}

// Slice
const CustomerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    setCustomer: (state, action: PayloadAction<Customer>) => {
      const { payload } = action
      state = payload
    },
  },
})

// Selectors
export const getCustomerSelector = (state: RootState): Customer => {
  return state.customer
}

// Actions
export const { setCustomer } = CustomerSlice.actions

// Reducers
export default CustomerSlice.reducer
